import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import SlideCart from '../SlideCart'
import PopInCart from '../PopinCart'

import { metaGiftOverride } from '../../utils/helpers'
import { getProducts, setProducts } from '../../store/modules/products/actions'
import Product from '../../models/product'

export default function Carts () {
  const dispatch = useDispatch()
  const products = useSelector(state => state.products)

  const [hasLoaded, setHasLoaded] = useState(false)

  const [availableSamples, setAvailableSamples] = useState([])
  const [samplesSettingTypesSkus, setSamplesSettingTypesSkus] = useState({})

  const [freeGiftsSelectionAvailable, setFreeGiftsSelectionAvailable] = useState(true)
  const [secondStepGiftsAvailable, setSecondStepGiftsAvailable] = useState(true)

  const getAvailableSamples = () => {
    const samplesSettingsContent = document.querySelector('meta[name="samples"]').content
    const samplesTypesSkusLines = samplesSettingsContent.split(';\n')
    const typesSkus = {}
    const samplesTypesSkus = () => {
      for (const samplesTypesSkusLine of samplesTypesSkusLines) {
        const [type, skus] = samplesTypesSkusLine.split('|')
        typesSkus[type] = skus?.split(',')
      }
      return typesSkus
    }

    setSamplesSettingTypesSkus(samplesTypesSkus())

    const samplesSettingsSkusLines = samplesTypesSkusLines && samplesTypesSkusLines.map(samplesTypesSkusLine => samplesTypesSkusLine.split('|')[1]).filter(s => s)
    const samplesSettingsSkus = samplesSettingsSkusLines && samplesSettingsSkusLines.map(samplesSettingsSkusLine => samplesSettingsSkusLine.split(',')).filter(s => s)
    const samplesSkus = samplesSettingsSkus && [...new Set(samplesSettingsSkus.flat())] // remove duplicates
    const availableSamples = (samplesSkus && products && products.filter(product => samplesSkus.includes(product.sku) && product.product_type === 'freebie').filter(s => s)) || []

    return availableSamples
  }

  useEffect(() => {
    dispatch(getProducts())
  }, [])

  useEffect(() => {
    if (products.length > 0 && !hasLoaded) {
      const variantsList = new Product(products)

      metaGiftOverride(variantsList, setSecondStepGiftsAvailable, setFreeGiftsSelectionAvailable)
      dispatch(setProducts(variantsList.variants))

      setHasLoaded(true)
    }
    if (hasLoaded) { setAvailableSamples(getAvailableSamples()) }
  }, [products])

  return (
    <>
      {hasLoaded &&
        <SlideCart
          products={products}
          freeGiftsSelectionAvailable={freeGiftsSelectionAvailable}
          secondStepGiftsAvailable={secondStepGiftsAvailable}
          availableSamples={availableSamples}
          samplesSettingTypesSkus={samplesSettingTypesSkus}
        />
      }

      {hasLoaded &&
        <PopInCart
          products={products}
          freeGiftsSelectionAvailable={freeGiftsSelectionAvailable}
          secondStepGiftsAvailable={secondStepGiftsAvailable}
          availableSamples={availableSamples}
          samplesSettingTypesSkus={samplesSettingTypesSkus}
        />
      }
    </>
  )
}
